export const formatFieldName = (fieldName: string) => {
  return fieldName?.replace(/([A-Z][a-z]+|[0-9]+)/g, " $1")?.trim();
};

export const formatPlaceholder = (fieldName: string) => {
  return formatFieldName(fieldName)?.toLowerCase();
};

export const formatFieldError = (fieldName: string) => {
  const text = formatFieldName(fieldName);
  return text.charAt(0) + text.slice(1)?.toLowerCase();
};

export const formatTitle = (title: string) => {
  return title
    ?.replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};
